export const apiUrl = 'https://www.terminslot.de/API'

export const endpoints = {
  // auth
  login: '/Auth/login',
  register: '/Auth/RegistrierenByEmail',
  forgotPassword: '/Auth/PasswortVergessen',
  resetPassword: '/Auth/PasswortReset',
  confirmEmail: '/Auth/BenutzerAktivieren',
  refreshToken: '/Auth/RefreshToken',

  // data
  salonData: '/Salon/GetSalonByGuid',
  employeeAvailableTimes: '/Mitarbeiter/GetAvailableTimeSlots',
  confirmBookingForNewUser: '/Mitarbeiter/InsertTerminBenutzer',
  confirmBookingForRegisteredUser: '/Mitarbeiter/InsertTermin',

  // user data
  getUser: '/Benutzer/GetBenutzer',
  getUserBookings: '/Benutzer/GetTermine',
  deleteUser: '/Benutzer/DeleteBenutzer',

  // appointment
  checkCancelAppointment: '/Mitarbeiter/TerminAbsagenCheck',
  cancelAppointment: '/Mitarbeiter/TerminAbsagen'
}
